// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2484y","header":"ReportDetails_header__nh4r5","title":"ReportDetails_title__3lC6B","left":"ReportDetails_left__1Pi2m"};